import React, { useLayoutEffect, useState } from 'react';

import styled from 'styled-components';

const Overlay = styled.div`
  position: absolute;
  z-index: -1;
  pointer-events: none;
  box-sizing: border-box;
  border-style: solid;
  border-width: 1px;
  border-image-source: linear-gradient(to left, var(--active-blue), var(--negative-orange) 50%, var(--flamingo-pink));
  border-image-slice: 1;
  background-image: linear-gradient(to left, var(--lavender-pale), var(--cool-white));
`;

type Rect = {
  top: number;
  left: number;
  width: number;
  height: number;
};

type Props = {
  containerEl: HTMLElement | null;
  rowSelector: string;
  deps: React.DependencyList;
};

const HighlightedRowOverlay = ({ containerEl, rowSelector, deps }: Props) => {
  const [rect, setRect] = useState<Rect | null>(null);

  useLayoutEffect(() => {
    if (!containerEl) return undefined;

    const measure = () => {
      const row = containerEl.querySelector<HTMLElement>(rowSelector);
      if (!row) {
        setRect(null);
        return;
      }
      const containerBox = containerEl.getBoundingClientRect();
      const rowBox = row.getBoundingClientRect();
      setRect({
        top: rowBox.top - containerBox.top,
        left: rowBox.left - containerBox.left,
        width: rowBox.width,
        height: rowBox.height,
      });
    };

    measure();

    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(containerEl);

    return () => resizeObserver.disconnect();
  }, [containerEl, ...deps]);

  if (!rect) return null;

  return <Overlay style={{ top: rect.top, left: rect.left, width: rect.width, height: rect.height }} />;
};

export default HighlightedRowOverlay;
